<template>
  <div class="home">
    <!--<el-container>-->
      <!--&lt;!&ndash;网页头部&ndash;&gt;-->
      <!--<el-header style="padding: 0px"> <Header></Header></el-header>-->

      <!--&lt;!&ndash;网页显示的主要部分&ndash;&gt;-->
      <!--<el-container style="background: #F0F2F5;margin-top: 13px">-->
        <!--<el-main>-->
          <!--<router-view class="main"></router-view>-->
        <!--</el-main>-->
      <!--</el-container>-->
    <!--</el-container>-->

    <Header></Header>

    <div style="padding-top: 20px" v-bind:style="{minHeight: Height+'px'}">
      <router-view></router-view>
    </div>

    <!--底部备案信息-->
    <el-footer class="footer">
      <div style="text-align: center;padding-top: 20px">
        <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备20009522号-2</a>
        <a style="margin: auto 30px" href="https://beian.miit.gov.cn" target="_blank">网站备案号</a>
      </div>
    </el-footer>
  </div>
</template>

<script>
  import Header from '@/components/Header.vue'
  import {getRootColumn} from "@/api/get";

  import Vue from 'vue';
  import APlayer from '@moefe/vue-aplayer';
  // import Footer from '@/components/Footer.vue'

  Vue.use(APlayer, {
      defaultCover: 'https://github.com/u3u.png',
      productionTip: true,
  });

  export default {
      name: 'Home',
      components: {
          Header,
          // Footer
      },
      data() {
          return {
              rootColumnId: 0,
              rootColumnList: [],
          }
      },
      created(){
          // 获取左侧导航栏
          this.getRootColumn();
      },
      methods:{
          // 获取左侧导航栏
          getRootColumn(){
              getRootColumn().then(response => {
                  this.rootColumnList = response.data
              });
          },
      },
      mounted(){
        //动态设置内容高度，让footer始终居底，header+footer的高度是100+70(header的高度)
        this.Height = document.documentElement.clientHeight - 170;
        //监听浏览器窗口变化
        window.onresize = ()=> {this.Height = document.documentElement.clientHeight -170}
      }
}
</script>

<style scoped>
  .home{
    /*position:relative;*/
    /*width:100%;*/
    /*min-height:100%;*/
    /*margin-bottom: 100px;*/
  }
  /*.main{*/
    /*width: 60%;*/
    /*margin: 30px auto;*/
  /*}*/
  .footer{
    /*background: #ffffff;*/
  }
</style>
